import PaymentModal from './index.vue';
import ApiManager from '../core/api/index'
import configManager from '../core/config/index'
import { PAYMENT_METHOD, PayWayImages } from '../core/constants/api'
import { IOrderStatusClientParams, IPayInitClientParams, IPayPrechargeClientParams } from './types'
import { LANGUAGE_KEY } from '../core/constants/language'

export function getOrderStatus(params: IOrderStatusClientParams, showLoading?: boolean): Promise<any> {
  const { token, originNo } = params
  return ApiManager.getInstance()
    .pay.payCheck({
      token,
      origin_no: originNo,
    }, showLoading)
}

export function payMethodJudge() {
  let payMethod: string = 'wap'
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.includes('micromessenger')) {
    // 微信内
    if (ua.includes('windowswechat')) {
      payMethod = 'scan'
    } else {
      payMethod = 'mp'
    }
  } else {
    // 微信外
    let userAgentInfo = navigator.userAgent
    let Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
      'Mobile',
      'HarmonyOS',
      'HMSCore',
    ]
    let getArr = Agents.filter((i) => userAgentInfo.includes(i))
    getArr.length ? (payMethod = 'wap') : (payMethod = 'web')
  }
  return payMethod
}

export function allPayArr() {
  const localLanguage = configManager.getLanguage()
  let originArr = [
    // { id: PAYMENT_METHOD.ALIPAY_QRCODE, title: '支付宝支付', icon: 'qc-sprites-wechat_icon' }, // 支付宝（扫码），暂时不做
    {
      id: PAYMENT_METHOD.WECHAT_QRCODE,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_WECHAT_QRCODE],
      icon: 'qc-sprites-scan_wechat_icon',
      pay_type: 'wechat',
    }, //5 微信（扫码）,Native支付
    // {
    //   id: PAYMENT_METHOD.AIRWALLEX,
    //   title: localLanguage[LANGUAGE_KEY.PAYMENT_AIRWALLEX],
    //   icon: 'qc-sprites-airwallex_icon',
    //   pay_type: 'airWallex',
    // }, //13 空中云汇AirWallex,暂时不做
    // {
    //   id: PAYMENT_METHOD.THAILAND_PAY,
    //   title: localLanguage[LANGUAGE_KEY.PAYMENT_THAILAND],
    //   icon: 'qc-sprites-unipin_icon',
    //   pay_type: 'uniPin',
    // }, //14 泰国支付UniPin,暂时不做
    {
      id: PAYMENT_METHOD.EUROPE_AMERICA_PAY,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_EUROPE_AMERICA],
      icon: 'qc-sprites-visa_master_icon',
      pay_type: 'xsolla',
    }, //15 欧美支付Xsolla
    {
      id: PAYMENT_METHOD.TAIWAN_PAY,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_TAIWAN],
      icon: 'qc-sprites-mycard_icon',
      pay_type: 'myCard',
    }, //16 台湾支付MyCard
    {
      id: PAYMENT_METHOD.SOUTHEAST_ASIA_PAY,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_SOUTHEAST_ASIA],
      icon: 'qc-sprites-payermax_icon',
      pay_type: 'payerMax',
    }, //17 东南亚支付PayerMax
    {
      id: PAYMENT_METHOD.VIETNAM_PAY,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_VIETANM],
      icon: 'qc-sprites-upay_icon',
      pay_type: 'uPay',
    }, //18 越南支付UPay
    {
      id: PAYMENT_METHOD.PAY_PAY,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_PAY_PAY],
      icon: 'qc-sprites-paypay_icon',
      pay_type: 'PayPay',
    }, //19 payPay
    {
      id: PAYMENT_METHOD.PAY_PAL,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_PAY_PAL],
      icon: 'qc-sprites-paypal_icon',
      pay_type: 'PayPal',
    }, //20 payPal
    {
      id: PAYMENT_METHOD.PAY_LETTER,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_PAY_LETTER],
      icon: 'qc-sprites-payletter_icon',
      pay_type: 'Payletter',
    }, //21 payLetter
    {
      id: PAYMENT_METHOD.WECHAT_JSSDK,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_WECHAT_JSSDK],
      icon: 'qc-sprites-wechat_icon',
      pay_type: 'wechat',
    }, //22 微信内h5支付（jsapi支付）
    {
      id: PAYMENT_METHOD.WECHAT_H5,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_WECHAT_H5],
      icon: 'qc-sprites-wechat_icon',
      pay_type: 'wechat',
    }, //23 微信外h5支付
    {
      id: PAYMENT_METHOD.ALIPAY_MOBILE_WEB,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ALIPAY_MOBILE_WEB],
      icon: 'qc-sprites-alipay_icon',
      pay_type: 'alipay',
    }, //24 支付宝（手机网站支付）
    {
      id: PAYMENT_METHOD.ALIPAY_PC_WEB,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ALIPAY_PC_WEB],
      icon: 'qc-sprites-alipay_icon',
      pay_type: 'alipay',
    }, //25 支付宝（电脑网站支付）
    {
      id: PAYMENT_METHOD.ALIPAY_INTERNATIONAL_CARD,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_CARD],
      icon: 'qc-sprites-visa_master_icon',
      pay_type: 'alipay-card',
    }, //26 蚂蚁国际支付antom-card
    {
      id: PAYMENT_METHOD.ALIPAY_INTERNATIONAL_GOOGLE,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_GOOGLE],
      icon: 'qc-sprites-google_pay_icon',
      pay_type: 'alipay-google',
    }, //27 蚂蚁国际支付antom-google
    {
      id: PAYMENT_METHOD.ALIPAY_INTERNATIONAL_PAYPAL,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_PAYPAL],
      icon: 'qc-sprites-paypal_icon',
      pay_type: 'alipay-paypal',
    }, //28 蚂蚁国际支付antom-paypal
    {
      id: PAYMENT_METHOD.ALIPAY_INTERNATIONAL_APPLE,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_APPLE],
      icon: 'qc-sprites-apple_pay_icon',
      pay_type: 'alipay-apple',
    }, //29 蚂蚁国际支付antom-apple
    {
      id: PAYMENT_METHOD.XSOLLA_PAYPAL,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_XSOLLA_PAYPAL],
      icon: 'qc-sprites-paypal_icon',
      pay_type: 'xsolla-paypal',
    }, //30 欧美支付 (Xsolla-paypal)
    {
      id: PAYMENT_METHOD.ALIPAY_INTERNATIONAL,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL],
      icon: 'qc-sprites-ant_INTL_icon',
      pay_type: 'alipay-international',
    }, //31 蚂蚁国际支付antom
    {
      id: PAYMENT_METHOD.PAYERMAX_CARD,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_PAYERMAX_CARD],
      icon: 'qc-sprites-payermax_card_icon',
      pay_type: 'payerMax-card',
    }, //33 PayerMax-card
    {
      id: PAYMENT_METHOD.PAYERMAX_GOOGLE,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_PAYERMAX_GOOGLE],
      icon: 'qc-sprites-google_pay_icon',
      pay_type: 'payerMax-google',
    }, //34 PayerMax-Google
    {
      id: PAYMENT_METHOD.PAYERMAX_APPLE,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_PAYERMAX_APPLE],
      icon: 'qc-sprites-apple_pay_icon',
      pay_type: 'payerMax-apple',
    }, //35 PayerMax-Apple
    {
      id: PAYMENT_METHOD.ENJOYPAY_CARD,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ENJOYPAY_CARD],
      icon: 'qc-sprites-payermax_card_icon',
      pay_type: 'enjoyPay-card',
    }, //36 EnjoyPay-Card
    {
      id: PAYMENT_METHOD.ENJOYPAY_APPLE,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ENJOYPAY_APPLE],
      icon: 'qc-sprites-apple_pay_icon',
      pay_type: 'enjoyPay-apple',
    }, //37 EnjoyPay-Apple
    {
      id: PAYMENT_METHOD.ENJOYPAY_GOOGLE,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ENJOYPAY_GOOGLE],
      icon: 'qc-sprites-google_pay_icon',
      pay_type: 'enjoyPay-google',
    }, //38 EnjoyPay-Google
    {
      id: PAYMENT_METHOD.ENJOYPAY_PAYPAY,
      title: localLanguage[LANGUAGE_KEY.PAYMENT_ENJOYPAY_PAYPAY],
      icon: 'qc-sprites-paypay_icon',
      pay_type: 'enjoyPay-paypay',
    }, //39 EnjoyPay-Paypay
  ]
  return originArr.map((item) => {
    return {
      ...item,
      img: PayWayImages[PAYMENT_METHOD.getKeyByValue(item.id) as string]
    }
  })
}

// 直接展示支付方式用，无需校验trade_no
export async function payInit(params: IPayInitClientParams): Promise<any> {
  let payMethod = 'wrap'
  payMethod = payMethodJudge()
  const allPayTypes = allPayArr()
  const { tradeNo, ...restParams } = params
  const response = await ApiManager.getInstance().pay.payInit({
    ...restParams,
    trade_no: tradeNo || '',
    is_close_check: 1 //关闭校验
  })
  const { code, metadata, message } = response || {}
  return new Promise((resolve, reject) => {
    if (code === 200) {
      const { pay_type = [], latest_pay_type } = metadata
      let payArr = pay_type
      switch (payMethod) {
        // 在pc微信打开
        case 'scan':
          payArr = payArr.filter((item: number) =>
            [PAYMENT_METHOD.WECHAT_QRCODE].includes(item)
          ) // 电脑微信只显示微信扫码
          break
        case 'mp':
          payArr = payArr.filter((item: number) =>
            [
              PAYMENT_METHOD.WECHAT_JSSDK
            ].includes(item)
          ) // 其余微信环境显示
          break
        case 'web':
          payArr = payArr.filter(
            (item: number) =>
              ![
                PAYMENT_METHOD.WECHAT_JSSDK,
                PAYMENT_METHOD.WECHAT_H5,
                PAYMENT_METHOD.ALIPAY_MOBILE_WEB,
              ].includes(item)
          )
          break
        case 'wap':
          payArr = payArr.filter(
            (item: number) =>
              ![
                PAYMENT_METHOD.WECHAT_QRCODE,
                PAYMENT_METHOD.WECHAT_JSSDK,
                PAYMENT_METHOD.ALIPAY_PC_WEB,
              ].includes(item)
          )
          break
        default:
          console.log('unknown pay method')
      }
      const payTypeMap = new Map(allPayTypes.map(item => [item.id, item]))
      resolve({
        code,
        message: 'success',
        data: payArr.map((id: number) => {
          const item = payTypeMap.get(id)
          if (!item) return null // 如果可能存在payArr中有id在allPayTypes中找不到的情况
          const { icon, ...rest } = item // 去掉icon
          return {
            ...rest,
            is_last_pay: latest_pay_type === id // 判断是否是上一次支付的方式
          }
        }).filter(Boolean)
      })
    } else {
      reject({
        code,
        message,
        data: []
      })
    }
  })
}

// 需校验trade_no
export async function payPrecharge(params: IPayPrechargeClientParams): Promise<any> {
  const {
    roleId,
    serverId,
    productId,
    productDesc,
    tradeNo,
    returnUrl,
    notifyUrl,
    isPayBehalf,
    isCard,
    type,
    isRefund,
    ...restParams
  } = params
  const open_id = sessionStorage.getItem('wechatOpenId')
  const isNeedWechatPay = configManager.get('isNeedWechatPay')
  const response = await ApiManager.getInstance().pay.payPrecharge({
    ...restParams,
    type,
    role_id: roleId,
    server_id: serverId,
    product_id: productId,
    product_desc: productDesc,
    trade_no: tradeNo,
    return_url: returnUrl,
    notify_url: notifyUrl,
    is_pay_behalf: isPayBehalf,
    is_card: isCard,
    oauth_id: open_id && isNeedWechatPay ? open_id : undefined,
    is_check_trade_no: 1, // 校验订单
    is_refund: isRefund,
  })
  return new Promise((resolve, reject) => {
    if (response.code === 200) {
        const { appid, sign, timestamp, noncestr, package: wxpackage, origin_no } = response.metadata
        if(type === PAYMENT_METHOD.WECHAT_JSSDK) {
          localStorage.setItem("originNo", origin_no)
          // @ts-ignore
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              appId: appid, //公众号ID，由商户传入
              timeStamp: timestamp, //时间戳，自1970年以来的秒数
              nonceStr: noncestr, //随机串
              package: wxpackage,
              signType: 'RSA', //微信签名方式：v3版本
              paySign: sign, //微信签名
            },
            function(res: { err_msg: string }) {
              if (res.err_msg === 'get_brand_wcpay_request:ok') {
                window.location.href = returnUrl
              } else {
                // 取消或者支付失败
                localStorage.setItem("originNo", '')
              }
            }
          )
        } else {
          resolve(response)
        }
    } else {
      reject(response)
    }
  })
}

export { PaymentModal };
export default PaymentModal;